import gql from 'graphql-tag';

import serviceActionMetadata from '../fragment/serviceActionMetadata';
import serviceActions from '../fragment/serviceActions';
import serviceCategories from '../fragment/serviceCategories';
import serviceInfo from '../fragment/serviceInfo';
import serviceMetadata from '../fragment/serviceMetadata';

/* eslint-disable graphql/no-deprecated-fields */
// FIXME: Get rid of deprecated `Query.services` field. Being tracked here:
// https://zapierorg.atlassian.net/browse/FLX-1772
export default gql`
  ${serviceActionMetadata}
  ${serviceActions}
  ${serviceCategories}
  ${serviceInfo}
  ${serviceMetadata}

  query servicesByIds($ids: [String!]!) {
    services(ids: $ids) {
      ...serviceActionMetadata
      ...serviceActions
      ...serviceCategories
      ...serviceInfo
      ...serviceMetadata
    }
  }
`;
/* eslint-enable graphql/no-deprecated-fields */
